import React from 'react';
import PropTypes from 'prop-types';
import { DisplayableContent } from './ConnectedKfaPropTypes';
import { AnalysisTitleLink } from './AnalysisTitleLink';

export const AnalysesTableRow = ({ analyses, hypothesisIndex, projectId }) => {
  return (
    analyses.length > 0 && (
      <ul className="connected-analyses__list">
        {analyses.map((analysis, index) => (
          <li key={analysis.contentId}>
            <AnalysisTitleLink
              key={analysis.contentId}
              analysis={analysis}
              projectId={projectId}
              testId={`kfa-connected-analysis-title-${hypothesisIndex}-${index}`}
            />
          </li>
        ))}
      </ul>
    )
  );
};

AnalysesTableRow.propTypes = {
  analyses: PropTypes.arrayOf(PropTypes.shape(DisplayableContent)).isRequired,
  hypothesisIndex: PropTypes.number.isRequired,
  projectId: PropTypes.string.isRequired,
};
